export function onlyPhoneDigits(value: string): string {
  return value.replace(/\D/g, '').replace(/^55(?=\d{10,11}$)/, '').slice(0, 11)
}

/**
 * Máscara de telefone brasileiro: (DD) XXXXX-XXXX ou (DD) XXXX-XXXX
 */
export function maskBrazilianPhone(value: string): string {
  const digits = onlyPhoneDigits(value)

  if (digits.length <= 2) return digits
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`
  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`
  }

  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`
}
